import { ContactFormState } from '../../slices/contactForm';

export type LegacyProjectContactFormFetcherArgs = {
  email: string;
  message: string;
  name: string;
  phone: string;
  projectCommuneId: number;
  projectId: number;
  recaptchaToken: string;
  recaptchaAction: string;
  source: ContactFormState['source'];
};

export default async function legacyProjectContactFormFetcher({
  email,
  message,
  name,
  phone,
  projectCommuneId,
  projectId,
  recaptchaToken,
  recaptchaAction,
  source
}: LegacyProjectContactFormFetcherArgs) {
  const projectIdStringified = projectId.toString();

  const getAjaxDataFormData = new FormData();

  getAjaxDataFormData.append('email', email);
  getAjaxDataFormData.append('proyecto', projectIdStringified);
  getAjaxDataFormData.append('ajax_request', 'cotizacion_email');

  await fetch(`${process.env.NEXT_PUBLIC_LEGACY_HOST}/get_ajax_data.php`, {
    method: 'POST',
    body: getAjaxDataFormData
  });

  const mailSenderFormData = new FormData();

  mailSenderFormData.append('cod', projectId.toString());
  mailSenderFormData.append('proy_id', projectIdStringified);
  mailSenderFormData.append('comuna_id', projectCommuneId.toString());
  mailSenderFormData.append('nombre', name);
  mailSenderFormData.append('telefono', phone);
  mailSenderFormData.append('email', email);
  mailSenderFormData.append('mensaje', message);
  mailSenderFormData.append('tipo_cotizacion', source);

  const query = new URLSearchParams({
    'pais': process.env.NEXT_PUBLIC_COUNTRY,
    'g-recaptcha-response': recaptchaToken,
    recaptchaAction
  }).toString();

  return fetch(
    `${process.env.NEXT_PUBLIC_LEGACY_HOST}/mailsender-proyectos.php?${query}`,
    {
      method: 'POST',
      body: mailSenderFormData
    }
  );
}
